<template>
  <footer :class="['padding-x summary-container gray-form-bg-fill', klass]">
    <div class="max-1200">
      <div :class="['flex-box vertically-centered margin-auto', isGovernment() ? 'government' : '']">
        <div class="annual-cost">
          <div class="big-number estimated-time-value">
            {{annualCost}}
          </div>
          <div class="caption-text1 gray">per year</div>
        </div>
        <div class="middle-block" v-if="isGovernment()">
          <div class="big-number estimated-time-value">{{estimatedTime}}</div>
          <div class="estimated-time caption-text1 gray">average time to launch</div>
        </div>
        <div class="next-button" >
          <SymbiumButton
            text="Continue"
            :onClick="goToCheckOut"
            :isSmall="true"
          />
        </div>
      </div>
    </div>
    <CostTooltipModal />
  </footer>
</template>

<script>

import SymbiumButton from 'src/components/common/SymbiumButton.vue'
import CostTooltipModal from 'src/components/common/modals/CostTooltipModal.vue'
import EventBus from '../EventBus.js'
import _ from 'lodash'

export default {
  name: 'SummaryContainer',
  props: ['klass', 'href'],
  components: { SymbiumButton, CostTooltipModal },
  data: function() {
    return {
      annualCost: this.calculateAnualCost(),
      estimatedTime: this.calculateEstimatedTime(),
      errors: {},
    }
  },
  methods: {
    showCostTooltipModal() {
      this.$modal.show('cost-tooltip-modal')
    },
    isGovernment: function() {
      return this.$questionnaire.isGovernment();
    },
    isBusiness: function() {
      return this.$questionnaire.isBusiness();
    },
    goToCheckOut: function() {
      if (this.isCartReady()) {
        this.$cart.setCheckOutCart();
        this.$questionnaire.clearContacts();
        this.$questionnaire.setContactAttribute(0, "firstName", '');
        this.$questionnaire.setAnswer('numberOfAccounts', 5);
        this.$router.push(this.href)
      } else {
        EventBus.$emit('cart-error', this.errors);
      }
    },
    calculateEstimatedTime: function() {
      return this.$cart.estimatedTime(this.$questionnaire);
    },
    calculateAnualCost() {
      return this.$cart.annualCost(this.$questionnaire);
    },
    reloadData: function() {
      this.annualCost = this.calculateAnualCost();
      this.estimatedTime = this.calculateEstimatedTime();
    },
    isCartReady: function() {
      var ready = true;
      this.errors = {};
      if (this.$questionnaire.isGovernment()) {
        ready = this.validateField('organizationCity') && ready
        ready = this.validateField('organizationSize') && ready

        if (this.$cart.hasDataProduct() && !this.$cart.isEmpty()) {
          ready = this.validateField('aduPrimarySource') && ready
          ready = this.validateField('Building area & footprints') && ready

          ready = this.validateField('Zoning district boundaries') && ready
          ready = this.validateField('Streets') && ready
          ready = this.validateField('Parcel boundaries') && ready
        }
        if (!this.$cart.hasDataProduct() && !this.$cart.isEmpty()) {
          ready = this.validateField('Zoning district boundaries') && ready
          ready = this.validateField('Streets') && ready
          ready = this.validateField('Parcel boundaries') && ready
        }
      } else if (this.$questionnaire.isBusiness()) {
        ready = this.validateField('organizationName') && ready
      }

      ready = ready && this.validateField('organizationType')

      if(this.$cart.isEmpty()) {
        this.errors.cart = "Please select at least one product";
        ready = false;
      }
      return ready;
    },
    validateField(key) {
      var ready = true;
      if (!this.$questionnaire.getAnswer(key).value) {
        this.errors[key] = "Please specify your answer";
        ready = false;
      }
      return ready;
    },
    validateContacts() {
      var allContacts = this.$questionnaire.getAllContacts();
      var ready = true;
      var emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line
      var isGovernment = this.$questionnaire.isGovernment();
      var isBusiness = this.$questionnaire.isBusiness();
      _.each(allContacts, function(contact) {
        if (!emailRegex.test(contact.email)) {
          ready = false;
        }

        if (isGovernment && (!contact.firstName || !contact.lastName || !contact.title)) {
          ready = false;
        }
        if (isBusiness && (!contact.firstName || !contact.lastName || !contact.phone)) {
          ready = false;
        }
      });

      return ready;
    }
  },
  mounted() {
    this.reloadData();
  },
  created() {
    EventBus.$on(EventBus.onCartChangedEvent, this.reloadData);
    EventBus.$on(EventBus.onAnswerChangedEvent, this.reloadData);
  },
  beforeDestroy() {
    EventBus.$off(EventBus.onCartChangedEvent, this.reloadData);
    EventBus.$off(EventBus.onAnswerChangedEvent, this.reloadData);
  },
}
</script>
<style lang="scss">
  .summary-container {
    height: 120px;
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
    box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.05), 0px 2px 4px rgba(0, 0, 0, 0.15);

    .max-size {
      height: 100%;
    }

    @media screen and (max-width: 768px) {
      height: auto;
      padding: 12px 0;
    }
  }

  .middle-block, .next-button, .annual-cost {
    flex-grow: 1;
  }

  .next-button {
    display: flex;
    justify-content: flex-end;
  }

  .estimated-time-value, .annual-cost-value {
    font-weight: 600;
  }

  .flex-box {
    height: 100%;
  }

  .continue {
    flex-grow: 1;
  }

  @media screen and (max-width: 768px) {
    .estimated-time {
      width: 80px;
    }

    .big-number {
      font-weight: bold;
    }
  }

  .summary-container .vertically-centered {
    .annual-cost {
      width: calc(25% - 24px);
      min-width: 120px;
    }

    @media screen and (max-width: 768px) {
      .annual-cost, .middle-block {
        margin-right: 16px;
      }
    }

    &.government {
      @media screen and (max-width: 768px) {
        align-items: initial;
        flex-wrap: wrap;
        row-gap: 24px;
      }
    }
  }

.cost-tooltip {
  width: 16px;
  cursor: pointer;
}
</style>
